
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M15.376.372C7.272.372.702 6.942.702 15.045c0 8.105 6.57 14.675 14.674 14.675S30.05 23.15 30.05 15.045C30.05 6.942 23.48.372 15.376.372z","stroke":"#515358","stroke-miterlimit":"10"}}),_c('g',{attrs:{"fill":"#515358"}},[_c('path',{attrs:{"d":"M16.565 22.443c0 .867-.706 1.572-1.572 1.572a1.574 1.574 0 01-1.573-1.572c0-.867.705-1.573 1.573-1.573.866 0 1.572.706 1.572 1.573M14.487 6.901v13.01a2.587 2.587 0 00-2.058 2.86 2.592 2.592 0 002.27 2.239 2.587 2.587 0 002.877-2.567 2.584 2.584 0 00-2.08-2.533V6.9"}}),_c('path',{attrs:{"d":"M22.244 8.82c0 .073-.06.134-.133.134h-1.51a.135.135 0 01-.136-.133V7.31c0-.075.061-.133.136-.133h1.51c.073 0 .133.058.133.133v1.51zm-.135-2.653H20.6c-.633 0-1.144.513-1.144 1.144v1.51c0 .63.511 1.144 1.144 1.144h.25v.95c0 .988-.654 1.857-1.602 2.13l-2.945.85v1.052l3.226-.932a3.242 3.242 0 002.33-3.1v-.95h.251c.63 0 1.144-.514 1.144-1.144V7.31c0-.63-.513-1.144-1.146-1.144zM8.628 12.034c-.562 0-1.02-.458-1.02-1.02a1.02 1.02 0 111.02 1.021zm2.108 4.218a2.219 2.219 0 01-1.602-2.132v-1.142a2.03 2.03 0 00-.118-3.96 2.033 2.033 0 00-2.417 1.995c0 .945.649 1.738 1.524 1.965v1.142c0 1.437.952 2.702 2.332 3.102l3.224.932v-1.05l-2.943-.852z"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/cable.svg